import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


function CmsElementVideo(props) {
  const { editMode, index, showElementSettings } = props;

  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  const shownClass = shown ? 'elem-shown' : 'elem-hidden';
  const aspectRatio = getParamValue('videoAspectRatio', '16-9');
  const wrapperClass = `ms-video-wrapper ms-video-wrapper-${aspectRatio}`;
  const videoUrl = getParamValue('videoUrl', '');

  const innerContent = (
    <div
      id={getMainId()}
      className={`${wrapperClass} ${shownClass} bg-master-lightest ${cssClasses} ${responsiveClasses}`}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={{
        ...getBackgroundStyle(),
        position: 'relative', // Ensure relative positioning for absolute centering
        overflow: 'hidden',
      }}
    >
      {elementStyleTag}

      {/*
          Centered Content Wrapper:
          Using absolute positioning and flexbox to guarantee perfect centering
          regardless of the padding-bottom trick used for aspect ratio.
      */}
      <div
        className="ms-video-player-content"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '15px',
        }}
      >
        <i className="fa fa-video fa-4x" />
        {videoUrl && (
          <div
            className="m-t-10"
            style={{
              wordBreak: 'break-all',
              maxWidth: '90%',
              fontSize: '0.9rem',
              opacity: 0.8,
            }}
          >
            {videoUrl}
          </div>
        )}
      </div>

      {getAppendHtml()}
    </div>
  );

  const parallaxData = getParallaxData();

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementVideo;
